angular.module('satv.playlist.pitch')
.controller('PitchActivityCtrl', ['$scope', 'PlaylistItemsLoader', 'Stat', function ($scope, PlaylistItemsLoader, Stat) {
    'use strict';

    $scope.init = function(pitch, isAnon) {
        if (isAnon === undefined) {
            isAnon = true;
        }

        isAnon = isAnon === true ? true : undefined;

        $scope.playlistItemsLoader = new PlaylistItemsLoader({
            playlistId: pitch.playlist.id
        }).getAll();

        Stat.query({
            type: 'audition',
            'context[name]': 'pitch',
            'context[data]': pitch.hash,
            isAnon: isAnon,
            groupBy: 'subject'
        }, function(r) {
            $scope.auditionStats = r;
        });

        Stat.query({
            type: 'download',
            'context[name]': 'pitch',
            'context[data]': pitch.hash,
            isAnon: isAnon,
            groupBy: 'subject',
        }, function(r) {
            $scope.downloadStats = r;
        });
    };

    function findStatTotal(subject, stats) {
        if (stats) {
            for (var i = 0; i < stats.data.length; i++) {
                if (stats.data[i].subject &&
                    stats.data[i].subject.id === subject.id
                ) {
                    return stats.data[i].total;
                }
            }
            return 0;
        }
    }

    $scope.getNoAuditions = function(subject) {
        return findStatTotal(subject, $scope.auditionStats);
    };

    $scope.getNoDownloads = function(subject) {
        return findStatTotal(subject, $scope.downloadStats);
    };

    $scope.getDeletedSubjects = function() {
        var subjects = [],
            allStats = [],
            addIds = [],
            inPlaylistIds = [];

        if ($scope.auditionStats &&
            $scope.downloadStats &&
            $scope.playlistItemsLoader.data
        ) {
            //combine all stats
            allStats = $scope.auditionStats.data.concat($scope.downloadStats.data);

            //collect subject.ids of subjects that are in playlists
            inPlaylistIds = $scope.playlistItemsLoader.data.map(function(s) {
                return s.id;
            });

            subjects = subjects.concat(
                allStats
                    .map(function(stat) {
                        return stat.subject;
                    })
                    .filter(function(subject) {
                        //a subject is deleted if (1) it hasn't already been added and
                        //(2) if it isn't in the playlist
                        if (addIds.indexOf(subject.id) === -1 &&
                            inPlaylistIds.indexOf(subject.id) === -1
                        ) {
                            addIds.push(subject.id);
                            return true;
                        }
                    })
            );
        }

        return subjects;
    };
}]);


// WEBPACK FOOTER //
// ./vendor/sonyatv/playlistpitchclientbundle/Resources/js/angular/controllers/PitchActivityCtrl.js